import { c as _c } from "react/compiler-runtime";
import { Button, Flex, Text } from '@chakra-ui/react';
import { LuArchive, LuArchiveRestore, LuTrash2, LuX } from 'react-icons/lu';
export type NetworkBulkActionBarProps = {
  selectedCount: number;
  /** How many of the selected networks each action applies to. An action
   * runs on that subset only; the rest of the selection is left alone. */
  deletableCount: number;
  retirableCount: number;
  retiredCount: number;
  /** The most networks one batch request accepts (`MAX_BULK_NETWORK_ACTION_SIZE`). */
  maxBatchSize: number;
  isPending: boolean;
  onDelete: () => void;
  onRetire: () => void;
  onUnretire: () => void;
  onClear: () => void;
};
const countLabel = (label: string, count: number, selected: number): string => count === selected ? label : `${label} ${count}`;
export default function NetworkBulkActionBar(t0) {
  const $ = _c(43);
  const {
    selectedCount,
    deletableCount,
    retirableCount,
    retiredCount,
    maxBatchSize,
    isPending,
    onDelete,
    onRetire,
    onUnretire,
    onClear
  } = t0;
  const isOverBatchLimit = selectedCount > maxBatchSize;
  const actionsDisabled = isPending || isOverBatchLimit;
  let t1;
  if ($[0] !== selectedCount) {
    t1 = <Text fontSize="sm" fontWeight="medium">{selectedCount} selected</Text>;
    $[0] = selectedCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isOverBatchLimit || $[3] !== maxBatchSize) {
    t2 = isOverBatchLimit && <Text color="red.600" fontSize="sm">Select at most {maxBatchSize} at a time</Text>;
    $[2] = isOverBatchLimit;
    $[3] = maxBatchSize;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = actionsDisabled || deletableCount === 0;
  const t4 = deletableCount < selectedCount ? "The master, release branches and released networks are skipped" : undefined;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LuTrash2 />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== deletableCount || $[7] !== selectedCount) {
    t6 = countLabel("Delete", deletableCount, selectedCount);
    $[6] = deletableCount;
    $[7] = selectedCount;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onDelete || $[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <Button aria-label="bulk-delete-networks" colorPalette="red" disabled={t3} size="xs" title={t4} variant="outline" onClick={onDelete}>{t5}{t6}</Button>;
    $[9] = onDelete;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = actionsDisabled || retirableCount === 0;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LuArchive />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== retirableCount || $[16] !== selectedCount) {
    t10 = countLabel("Retire", retirableCount, selectedCount);
    $[15] = retirableCount;
    $[16] = selectedCount;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onRetire || $[19] !== t10 || $[20] !== t8) {
    t11 = <Button aria-label="bulk-retire-networks" disabled={t8} size="xs" variant="outline" onClick={onRetire}>{t9}{t10}</Button>;
    $[18] = onRetire;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = actionsDisabled || retiredCount === 0;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <LuArchiveRestore />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== retiredCount || $[24] !== selectedCount) {
    t14 = countLabel("Unretire", retiredCount, selectedCount);
    $[23] = retiredCount;
    $[24] = selectedCount;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== onUnretire || $[27] !== t12 || $[28] !== t14) {
    t15 = <Button aria-label="bulk-unretire-networks" disabled={t12} size="xs" variant="outline" onClick={onUnretire}>{t13}{t14}</Button>;
    $[26] = onUnretire;
    $[27] = t12;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <LuX />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== isPending || $[32] !== onClear) {
    t17 = <Button aria-label="clear-network-selection" disabled={isPending} size="xs" variant="ghost" onClick={onClear}>{t16}Clear</Button>;
    $[31] = isPending;
    $[32] = onClear;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t11 || $[35] !== t15 || $[36] !== t17 || $[37] !== t7) {
    t18 = <Flex gap={2} ml="auto" wrap="wrap">{t7}{t11}{t15}{t17}</Flex>;
    $[34] = t11;
    $[35] = t15;
    $[36] = t17;
    $[37] = t7;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t1 || $[40] !== t18 || $[41] !== t2) {
    t19 = <Flex alignItems="center" aria-label="network-bulk-action-bar" bg="blue.50" borderColor="blue.200" borderRadius="md" borderWidth="1px" gap={2} px={3} py={1.5} wrap="wrap">{t1}{t2}{t18}</Flex>;
    $[39] = t1;
    $[40] = t18;
    $[41] = t2;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
}